import React, { useEffect, useState } from 'react';
import "./HotelsTab.css"
import { HotelCard } from '../..'
import { axiosGet } from '../../../../utils/apis/api';
import Cookies from "js-cookie";
import { Paginations, SpinnerLoading} from '../../../../components';
import { useTranslation } from "../../../../contexts/TranslationContext";



const HotelsTab = () => {
    const { t } = useTranslation();
     const [hotelsData, setHotelsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const resultsPerPage = 10;

  const fetchHotels = async (pageNumber = 1) => {
    setLoading(true);
    try {
      const apiKey = Cookies.get("api_key");
      const apiSecret = Cookies.get("api_secret");

      const headers = {
        Authorization: `token ${apiKey}:${apiSecret}`,
      };

      const start = (pageNumber - 1) * resultsPerPage;

      const data = await axiosGet(
        "https://crm.alltimestravels.com/api/method/erpnext.selling.doctype.quotation.quotation.PackageQuotation",
        {
          quotation_type: "Hotel",
          start,
          limit: resultsPerPage,
        },
        headers
      );

      if (data.result) {
        setHotelsData(data.result.quotations || []);

        const meta = data.result.pagination?.metadata;
        setTotalPages(meta?.total_pages || Math.ceil((data.result.quotations?.length || 0) / resultsPerPage));

        setCurrentPage(pageNumber);
      } else {
        setHotelsData([]);
      }
    } catch (error) {
      console.error("Failed to fetch hotels:", error);
      setHotelsData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHotels(currentPage);
  }, []);

  const onPageChange = (page) => {
    fetchHotels(page);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
//     <div className='hotels-tab-contianer'>
//        <HotelCard
//             date={"Nov 8 – Nov 15 "}
//             travelers={"2 child | 1 Adult"}
//             title={"The Lana - Dorchester Collection"}
//             location={"Downtown, Dubai"}
//             price={"$159"}
//             discount={"$159"}
//        /> 
//        <HotelCard
//             date={"Nov 8 – Nov 15 "}
//             travelers={"2 child | 1 Adult"}
//             title={"The Lana - Dorchester Collection"}
//             location={"Downtown, Dubai"}
//             price={"$159"}
//             discount={"$159"}
//        /> 
//        <HotelCard
//             date={"Nov 8 – Nov 15 "}
//             travelers={"2 child | 1 Adult"}
//             title={"The Lana - Dorchester Collection"}
//             location={"Downtown, Dubai"}
//             price={"$159"}
//             discount={"$159"}
//        /> 
//        <HotelCard
//             date={"Nov 8 – Nov 15 "}
//             travelers={"2 child | 1 Adult"}
//             title={"The Lana - Dorchester Collection"}
//             location={"Downtown, Dubai"}
//             price={"$159"}
//             discount={"$159"}
//        /> 
//     </div>
<div>
     
      {loading ? (
         <div className="loading-container">
           <SpinnerLoading />
         </div>
      ) : hotelsData.length > 0 ? (
        <>
          <div className="hotels-tab-container">
            {hotelsData.map((hotel, index) => (
              <HotelCard
                key={index}
                date={`${hotel.start_date} – ${hotel.end_date}`}
                travelers={`${hotel.number_of_children} ${t("Child")} | ${hotel.number_of_adults} ${t("Adults")}`}
                title={hotel.hotel_name }
                location={hotel.destinations?.[0]?.location}
                price={`$${hotel.base_grand_total }`}
               //  discount={`$${hotel.discounted_total || hotel.base_grand_total || "0"}`}
              />
            ))}
          </div>

          <div className="d-flex justify-content-center mt-5">
            <Paginations
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={onPageChange}
            />
          </div>
        </>
      ) : (
        <p>{t("NoHotelsReserved")}</p>
      )}
    </div>
  )
}

export default HotelsTab
